export const traductor = (label, value) => {
  return {
    label: label,
    value: value,
  };
};
